var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import getattr from 'safe-object';
import queryString from 'query-string';
import pym from 'pym.js';

var THEMES = process.env.REACT_APP_THEMES;

var NyprWidgetBase = function (_Component) {
  _inherits(NyprWidgetBase, _Component);

  function NyprWidgetBase(props) {
    _classCallCheck(this, NyprWidgetBase);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      styles: {}
    };

    _this.listener = function (data) {
      var query = _this.parse(data);
      _this.setState(query);
    };

    _this.embed = new pym.Child({ polling: 200 });
    _this.embed.onMessage('incoming', _this.listener);
    _this.embed.sendMessage('mounted');

    if (window.location.search) {
      _this.state = _extends({}, _this.state, queryString.parse(window.location.search));
      if (_this.state.brand) {
        _this.updateBrand();
      }
    } else {
      _this.state = _extends({}, _this.state, props);
    }
    return _this;
  }

  NyprWidgetBase.prototype.componentWillUnmount = function componentWillUnmount() {
    this.embed.remove();
  };

  NyprWidgetBase.prototype.componentDidUpdate = function componentDidUpdate(props, _ref) {
    var brand = _ref.brand;

    if (this.state.brand !== brand) {
      this.updateBrand();
    }
  };

  NyprWidgetBase.prototype.updateBrand = function updateBrand() {
    var _this2 = this;

    fetch(THEMES + '/' + this.state.brand + '.json').then(function (r) {
      return r.json();
    }).then(function (styles) {
      return _this2.setState({ styles: styles });
    });
  };

  NyprWidgetBase.prototype.style = function style(path) {
    var parts = path.split('.');
    if (parts.length === 1) {
      // get everything nested under this path
      return this.state.styles[path];
    } else {
      var _ref2;

      // look for a specific path
      var key = parts.slice(-1);
      return _ref2 = {}, _ref2[key] = getattr(this.state, 'styles.' + path), _ref2;
    }
  };

  NyprWidgetBase.prototype.parse = function parse(data) {
    var message = {};
    if (typeof data === 'string') {
      try {
        message = JSON.parse(data);
      } catch (e) {/* Ignored */}
    }
    return message;
  };

  NyprWidgetBase.prototype.render = function render() {
    return null;
  };

  return NyprWidgetBase;
}(Component);

export { NyprWidgetBase as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/nypr-widget-base/es/index.js
// module id = 115
// module chunks = 0